import React from 'react'

import { PriceString, Radio } from '@fourthwall/components'

import type { Plan } from '../../AddSubscriptionModal.types'
import * as S from './PlanOption.styled'

export type PlanOptionProps = {
  plan: Plan
  selected: boolean
  onClick?: () => void
}

export const PlanOption = ({ plan, selected, onClick }: PlanOptionProps) => {
  return (
    <S.Container selected={selected} onClick={onClick}>
      <S.RadioContainer>
        <Radio checked={selected} />
      </S.RadioContainer>
      <S.Content>
        <S.Label>{plan.label}</S.Label>
        <S.Text>
          <PriceString {...plan.monthlyPrice} /> per month
        </S.Text>
        {plan.savings && (
          <S.SavingsTag>
            Save <PriceString {...plan.savings} />
          </S.SavingsTag>
        )}
      </S.Content>
    </S.Container>
  )
}
